import React, { useEffect, useRef } from "react"
import QRCode from 'qrcode'

const QRCodeComponent = ({ qrCodeUrl }) => {
  const canvasRef = useRef(null) 

  useEffect(() => {
    if (qrCodeUrl && canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, qrCodeUrl, { errorCorrectionLevel: 'H' }, (error) => {
        if (error) {
          console.error("Error generating QR code: ", error)
        }
      })
    }
  }, [qrCodeUrl])

  return (
    <div>
      {qrCodeUrl && <canvas ref={canvasRef} />}
    </div>
  )
}

export default QRCodeComponent
